import React, { useEffect } from 'react';
import ActivationInProgressPage from './view';
import { type ProgressBarStatus } from './activation-in-progress-background';
import { type ActivationStatus } from '../../state/activation/types';
import { type OnDemandActivationInProgressProps } from './types';
import {
	ExperiencePerformanceTypes,
	ExperienceTypes,
	UFOExperience,
	useUFOComponentExperience,
} from '@atlassian/ufo';

const ufoExperienceTracker = new UFOExperience('on-demand-activation-in-progress', {
	performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	type: ExperienceTypes.Load,
	platform: {
		component: 'project-pages',
	},
});

const activationStatusToProgress: Record<ActivationStatus, ProgressBarStatus> = {
	activating: 'in-progress',
	completed: 'completed',
	'not-started': 'not-started',
	allowed: 'not-started',
	error: 'error',
	'not-allowed': 'error',
};

const OnDemandActivationInProgress = ({
	startStatusCheck,
	changeModalState,
	status,
}: OnDemandActivationInProgressProps) => {
	useUFOComponentExperience(ufoExperienceTracker);
	useEffect(() => {
		startStatusCheck();
	}, [startStatusCheck]);

	useEffect(() => {
		if (status === 'completed') {
			ufoExperienceTracker.success();
		}
		if (status === 'error') {
			ufoExperienceTracker.failure();
		}
	}, [status]);

	const handleDismissModal = () => {
		changeModalState('closed');
	};
	const handleOpenModal = () => {
		changeModalState('open');
	};

	return (
		<ActivationInProgressPage
			status={activationStatusToProgress[status]}
			onDismiss={handleDismissModal}
			onOpen={handleOpenModal}
		/>
	);
};
export default OnDemandActivationInProgress;
